export default __webpack_public_path__ + "static/media/no-notification-icon.e5801840.svg";